import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlbums2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"albums-2, cover"} maskId="square-filled-radius-0-stroke-1-IconAlbums2"><path fillRule="evenodd" clipRule="evenodd" d="M21.125 11L18.9028 21H5.10061L2.87838 11H21.125ZM20.0017 8H4.00169V7H20.0017V8ZM19.0017 4H5.00169V3H19.0017V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlbums2;
